import React, {useCallback, useEffect, useRef, useState} from 'react';
import '@react-awesome-query-builder/ui/css/styles.css';
import '@react-awesome-query-builder/ui/css/compact_styles.css';
import TextField from '@mui/material/TextField';
import '@yaireo/tagify/dist/tagify.css'
import '../AlertForm.scss';
import {useParams} from "react-router-dom";
import {APP_ALERT_CENTER_API_ENDPOINT} from "../../../../constants/api_urls";
import CustomButtonWithIcon from "../../../../components/CustomButtonWithIcon/Buttons";
import {InputAdornment, Typography} from "@mui/material";
import { getUserToken } from "utils/functions/userToken";
import {getUserDetailsFromToken} from "../../../../utils/functions/userTokenDetails";
import AlertTextField from "../FormComponents/AlertTextField";
import AlertLevelSelector from "../FormComponents/AlertLevelSelector";
import HotelSelection from "../FormComponents/HotelSelection";
import GroupSelection from "../FormComponents/GroupSelection";
import RecipientsField from "../FormComponents/RecipientsField";

const AlertBaseForm = ({alertData, actionType, onClose, showSnackbar, refreshData }) => {

    const { idaccount } = useParams();
    let method = 'POST';
    let apiActionEndpoint = '';
    if(actionType === 'edit') {
        method = 'PUT';
        apiActionEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-budget/metasearch/edit/${idaccount}/` + alertData.id;
    }
    else {
        apiActionEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-budget/metasearch/add/${idaccount}`;
    }
    const jwtToken = getUserToken();

    const [alertName, setAlertName] = useState(alertData?.name || '');
    const [alertRecipients, setAlertalertRecipients] = useState(alertData?.recipients || []);
    const [alertCondition, setAlertCondition] = useState(alertData?.alertCondition || '');
    const tagifyRef = useRef(null);
    const [isHotelSlidingPanelOpen, setIsHotelSlidingPanelOpen] = useState(false);
    const [isGroupSlidingPanelOpen, setIsGroupSlidingPanelOpen] = useState(false);
    const [selectedHotels, setSelectedHotels] = useState([]);
    const [alertLevel, setAlertLevel] = useState(alertData?.alertLevel || "HOTEL");
    const [hotelRowSelection, setHotelRowSelection] = useState({});
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [groupRowSelection, setGroupRowSelection] = useState({});
    const [errorSelectedHotels, setErrorSelectedHotels] = useState(false);
    const [errorSelectedGroups, setErrorSelectedGroups] = useState(false);
    const [userDetails, setUserDetails] = useState({
        username: 'N/A',
        roles: 'N/A',
        isMainUser: false,
        isAdminUser: false,
        isSuperAdminUser: false
    });


    useEffect(() => {
        const token = getUserToken();
        const { UserDetails } = getUserDetailsFromToken(token);
        setUserDetails(UserDetails);
    }, []);

    const isAdminOrMainUser = userDetails.isAdminUser || userDetails.isSuperAdminUser || userDetails.isMainUser;

    console.log("alert data : ", alertData)
    const handleRemoveHotel = (hotelId) => {
        setSelectedHotels(prevHotels => prevHotels.filter(h => h.id !== hotelId));
        setHotelRowSelection(prevSelection => {
            const newSelection = { ...prevSelection };
            delete newSelection[hotelId];
            return newSelection;
        });
    };

    const handleRemoveGroups = (groupId) => {
        setSelectedGroups(prevGroups => prevGroups.filter(h => h.id !== groupId));
        setGroupRowSelection(prevSelection => {
            const newSelection = { ...prevSelection };
            delete newSelection[groupId];
            return newSelection;
        });
    };

    const handleGroupSelect = useCallback((selectedGroups) => {
        setSelectedGroups(selectedGroups);
    }, []);

    const handleClearAllHotels = () => {
        setSelectedHotels([]);
        setHotelRowSelection({});
    };

    const handleClearAllGroups = () => {
        setSelectedGroups([]);
        setGroupRowSelection({});
    };

    const handleHotelSelect = useCallback((selectedHotels) => {
        setSelectedHotels(selectedHotels);
    }, []);



    const [errors, setErrors] = useState({
        alertName: false,
        alertRecipients: false,
        alertCondition: false,
    });


    useEffect(() => {
        if (alertLevel === "HOTEL") {
            setSelectedGroups([]);
            setGroupRowSelection([]);
        } else if (alertLevel === "GROUP") {
            setSelectedHotels([]);
            setHotelRowSelection([]);
        } else {
            setSelectedGroups([]);
            setGroupRowSelection([]);
            setSelectedHotels([]);
            setHotelRowSelection([]);
        }
    }, [alertLevel]);


    useEffect(() => {
        const fetchLinkedHotels = async () => {
            if (alertData && actionType === 'edit' && alertLevel === 'HOTEL') {
                try {
                    const res = await fetch(`${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/list-linked-hotels/${alertData.id}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${jwtToken}`,
                            'Content-Type': 'application/json',
                        }
                    });
                    const hotels = await res.json();
                    setSelectedHotels(hotels);

                    const selectionMap = {};
                    hotels.forEach(hotel => {
                        selectionMap[hotel.id] = true;
                    });
                    setHotelRowSelection(selectionMap);
                } catch (error) {
                    console.error("Error fetching linked hotels:", error);
                }
            }
        };

        fetchLinkedHotels();
    }, [alertData, actionType, alertLevel]);

    useEffect(() => {
        const fetchLinkedGroups = async () => {
            if (alertData && actionType === 'edit' && alertLevel === 'GROUP') {
                try {
                    const res = await fetch(`${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/list-linked-groups/${alertData.id}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${jwtToken}`,
                            'Content-Type': 'application/json',
                        }
                    });
                    const groups = await res.json();
                    setSelectedGroups(groups);

                    const selectionMap = {};
                    groups.forEach(group => {
                        selectionMap[group.id] = true;
                    });
                    setGroupRowSelection(selectionMap);
                } catch (error) {
                    console.error("Error fetching linked groups:", error);
                }
            }
        };

        fetchLinkedGroups();
    }, [alertData, actionType, alertLevel]);

    const submitBudgetMetasearchAlert = (requestBody) => {
        fetch(apiActionEndpoint, {
            method: method,
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => {
                if (!response.ok) { // Check if the response is not OK (status code outside 200-299)
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                showSnackbar('Alert saved successfully');
                if (refreshData) {
                    refreshData();
                }
                onClose();
            })
            .catch((error) => {
                showSnackbar('Error saving alert: ' + error.message, 'error');
            });
    };

    const handleRecipientsChange = useCallback((e) => {
        let parsedValue;
        try {
            parsedValue = JSON.parse(e.detail.value); // Parser la chaîne JSON
        } catch (error) {
            console.error("Parsing error:", error);
            parsedValue = [];
        }

        const updatedRecipients = parsedValue.map(tag => tag.value);
        setAlertalertRecipients(updatedRecipients);
    }, []);

    const handleSubmit = async () => {
        const body = {
            alert_name: alertName,
            alert_recipients: alertRecipients,
            alert_condition: alertCondition,
            alert_level: alertLevel,
            alert_hotels_selection: selectedHotels.map(hotel => hotel.id),
            alert_groups_selection: selectedGroups.map(group => group.id)
        };
        const missingHotels = alertLevel === "HOTEL" && selectedHotels.length === 0;
        const missingGroups = alertLevel === "GROUP" && selectedGroups.length === 0;

        const newErrors = {
            alertName: !body.alert_name,
            alertRecipients: body.alert_recipients.length === 0,
            alertCondition: !body.alert_condition,
        };
        setErrors(newErrors);
        setErrorSelectedHotels(missingHotels);
        setErrorSelectedGroups(missingGroups)

        if (Object.values(newErrors).some(e => e) || missingHotels || missingGroups) {
            showSnackbar('Please fill in all required fields', 'error');
        } else {
            submitBudgetMetasearchAlert(body);
        }
    };

    return (
        <div className="alert-form">
            <div className="top-side">
                <AlertTextField
                    placeholder="Alert Name:"
                    value={alertName}
                    onChange={(e) => setAlertName(e.target.value)}
                    error={errors.alertName}
                    helperText="This field is required"
                />
            </div>
            <AlertLevelSelector
                value={alertLevel}
                onChange={(e) => setAlertLevel(e.target.value)}
                isAdminOrMainUser={isAdminOrMainUser}
                alertMetasearchBudget={true}
                error={errors.alertLevel}
            />
            {alertLevel === "HOTEL" && (
                <HotelSelection
                    isOpen={isHotelSlidingPanelOpen}
                    setOpen={setIsHotelSlidingPanelOpen}
                    selectedHotels={selectedHotels}
                    handleRemoveHotel={handleRemoveHotel}
                    handleClearAllHotels={handleClearAllHotels}
                    handleHotelSelect={handleHotelSelect}
                    hotelRowSelection={hotelRowSelection}
                    setHotelRowSelection={setHotelRowSelection}
                    idaccount={idaccount}
                    jwtToken={jwtToken}
                    showError={errorSelectedHotels}
                />
            )}
            {alertLevel === "GROUP" && isAdminOrMainUser && (

                <GroupSelection
                    isOpen={isGroupSlidingPanelOpen}
                    setOpen={setIsGroupSlidingPanelOpen}
                    selectedGroups={selectedGroups}
                    handleRemoveGroup={handleRemoveGroups}
                    handleClearAllGroups={handleClearAllGroups}
                    handleGroupSelect={handleGroupSelect}
                    groupRowSelection={groupRowSelection}
                    setGroupRowSelection={setGroupRowSelection}
                    idaccount={idaccount}
                    jwtToken={jwtToken}
                    showError={errorSelectedGroups}
                />
            )}

            <TextField
                placeholder="Alert me when my budget has reached"
                variant="standard"
                type="number"
                value={alertCondition}
                onChange={(e) => setAlertCondition(e.target.value)}
                required
                error={errors.alertCondition}
                helperText={errors.alertCondition ? 'This field is required' : ''}
                sx={{
                    '& ::placeholder': { fontSize: '12px' },
                    '& .MuiInputBase-input': {
                        fontSize: '12px',
                    },
                    width: '55%',
            }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Typography variant="body2" sx={{ fontSize: "12px", color: "#373F41" }}>
                                %
                            </Typography>
                        </InputAdornment>
                    ),
                }}
            />

            <RecipientsField
                value={alertRecipients}
                onChange={handleRecipientsChange}
                error={errors.alertRecipients}
            />

            <div className="button-container">
                <CustomButtonWithIcon
                    color="#b0acac"
                    hoverColor="#12794F"
                    titleColor="#373F41"
                    hoverTitleColor={"white"}
                    width={"120px"}
                    height={"24px"}
                    borderRadius="20px"
                    textStyle={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '14.52px',
                        textAlign: 'center',
                    }}
                    onClick={handleSubmit}

                >
                    Save Alert
                </CustomButtonWithIcon>

                <CustomButtonWithIcon
                    color="#b0acac"
                    hoverColor="#12794F"
                    titleColor="#373F41"
                    hoverTitleColor={"white"}
                    width={"120px"}
                    height={"24px"}
                    borderRadius="20px"
                    textStyle={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '14.52px',
                        textAlign: 'center',
                    }}
                    onClick={onClose}

                >
                    Cancel
                </CustomButtonWithIcon>
            </div>
        </div>
    );
};

export default AlertBaseForm;
